<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-list-tile v-on="on">
        <v-list-tile-title>{{ $t('buttons.selectIcon') }}</v-list-tile-title>
      </v-list-tile>
    </template>

    <v-card :color="$style.card.background">
      <CardToolbar :title="$t('pageHeader.selectIcon')" :isModal="true" @cancel="cancel" />
      <v-container grid-list-lg class="image-box">
        <v-text-field
          v-model="search"
          class="rounded"
          prepend-inner-icon="search"
          data-cy="searchBar"
          label="Search"
          :append-icon="`${search ? 'close' : ''}`"
          @click:append="search = ''"
          single-line
          solo
          hide-details
        />
        <v-layout row wrap>
          <v-flex
            xs2
            v-for="(item, index) in filterList"
            :key="index"
            @click="selectIcon(item)"
            class="pointer"
          >
            <div class="text-xs-center">
              <v-img :src="item.url" contain aspect-ratio="1.3333"></v-img>
              <span class="text-capitalize">{{ item.name }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>

      <v-card-actions class="cardAction">
        <div>{{filterList.length}}</div>
        <v-spacer></v-spacer>
        <v-btn color="info" text @click="cancel">{{ $t('buttons.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'icon-selection',
  data() {
    return {
      dialog: false,
      search: '',
      list: [
        { name: 'Beetroot', url: 'https://s3.amazonaws.com/4.0image/001-beetroot.png' },
        { name: 'cheese', url: 'https://s3.amazonaws.com/4.0image/001-cheese.png' },
        { name: 'Egg Rolls', url: 'https://s3.amazonaws.com/4.0image/001-egg-rolls.png' },
        { name: 'Macaron', url: 'https://s3.amazonaws.com/4.0image/001-macaron.png' },
        { name: 'Machine', url: 'https://s3.amazonaws.com/4.0image/001-machine.png' },
        { name: 'Carrot', url: 'https://s3.amazonaws.com/4.0image/002-carrot.png' },
        { name: 'Coffee', url: 'https://s3.amazonaws.com/4.0image/002-coffee.png' },
        { name: 'Dimsum', url: 'https://s3.amazonaws.com/4.0image/002-dimsum-1.png' },
        { name: 'Muffin', url: 'https://s3.amazonaws.com/4.0image/002-muffin.png' },
        { name: 'Van', url: 'https://s3.amazonaws.com/4.0image/002-van.png' },
        { name: 'Apple', url: 'https://s3.amazonaws.com/4.0image/003-apple.png' },
        { name: 'Dough', url: 'https://s3.amazonaws.com/4.0image/003-dough.png' },
        { name: 'fast food', url: 'https://s3.amazonaws.com/4.0image/003-fast+food.png' },
        { name: 'soy sauce', url: 'https://s3.amazonaws.com/4.0image/003-soy-sauce.png' },
        { name: 'van', url: 'https://s3.amazonaws.com/4.0image/003-van.png' },
        { name: 'apricot', url: 'https://s3.amazonaws.com/4.0image/004-apricot.png' },
        { name: 'noodle', url: 'https://s3.amazonaws.com/4.0image/004-noodle.png' },
        { name: 'pretzel', url: 'https://s3.amazonaws.com/4.0image/004-pretzel.png' },
        { name: 'shrimp', url: 'https://s3.amazonaws.com/4.0image/004-shrimp.png' },
        { name: 'van', url: 'https://s3.amazonaws.com/4.0image/004-van.png' },
        { name: 'avocado', url: 'https://s3.amazonaws.com/4.0image/005-avocado.png' },
        { name: 'stone oven', url: 'https://s3.amazonaws.com/4.0image/005-stone-oven.png' },
        { name: 'tea', url: 'https://s3.amazonaws.com/4.0image/005-tea.png' },
        { name: 'van', url: 'https://s3.amazonaws.com/4.0image/005-van.png' },
        { name: 'bananas', url: 'https://s3.amazonaws.com/4.0image/006-bananas.png' },
        { name: 'pasta', url: 'https://s3.amazonaws.com/4.0image/006-pasta.png' },
        { name: 'pasty', url: 'https://s3.amazonaws.com/4.0image/006-pasty.png' },
        { name: 'pudding', url: 'https://s3.amazonaws.com/4.0image/006-pudding.png' },
        { name: 'van', url: 'https://s3.amazonaws.com/4.0image/006-van.png' },
        { name: 'Bell pepper', url: 'https://s3.amazonaws.com/4.0image/007-Bell+pepper.png' },
        { name: 'measuring cup', url: 'https://s3.amazonaws.com/4.0image/007-measuring-cup.png' },
        { name: 'pinwheel', url: 'https://s3.amazonaws.com/4.0image/007-pinwheel.png' },
        { name: 'sausage', url: 'https://s3.amazonaws.com/4.0image/007-sausage.png' },
        { name: 'van', url: 'https://s3.amazonaws.com/4.0image/007-van.png' },
        { name: 'berry', url: 'https://s3.amazonaws.com/4.0image/008-berry.png' },
        { name: 'boiled egg', url: 'https://s3.amazonaws.com/4.0image/008-boiled+egg.png' },
        { name: 'dango', url: 'https://s3.amazonaws.com/4.0image/008-dango.png' },
        { name: 'flour', url: 'https://s3.amazonaws.com/4.0image/008-flour-1.png' },
        { name: 'hot dog', url: 'https://s3.amazonaws.com/4.0image/008-hot+dog.png' },
        { name: 'blueberry', url: 'https://s3.amazonaws.com/4.0image/009-blueberry.png' },
        { name: 'chocolate bar', url: 'https://s3.amazonaws.com/4.0image/009-chocolate+bar.png' },
        { name: 'egg', url: 'https://s3.amazonaws.com/4.0image/009-egg.png' },
        { name: 'hot dog', url: 'https://s3.amazonaws.com/4.0image/009-hot+dog.png' },
        { name: 'roll cake', url: 'https://s3.amazonaws.com/4.0image/009-roll-cake.png' },
        { name: 'baguette', url: 'https://s3.amazonaws.com/4.0image/010-baguette.png' },
        { name: 'eggplant', url: 'https://s3.amazonaws.com/4.0image/010-eggplant.png' },
        { name: 'salt', url: 'https://s3.amazonaws.com/4.0image/010-salt.png' },
        { name: 'skewer', url: 'https://s3.amazonaws.com/4.0image/010-skewer.png' },
        { name: 'trailer', url: 'https://s3.amazonaws.com/4.0image/010-trailer.png' },
        { name: 'broccoli', url: 'https://s3.amazonaws.com/4.0image/011-broccoli.png' },
        { name: 'fish', url: 'https://s3.amazonaws.com/4.0image/011-fish.png' },
        { name: 'rice', url: 'https://s3.amazonaws.com/4.0image/011-rice.png' },
        { name: 'van', url: 'https://s3.amazonaws.com/4.0image/011-van.png' },
        { name: 'wind mill', url: 'https://s3.amazonaws.com/4.0image/011-wind-mill.png' },
        { name: 'Capsicum', url: 'https://s3.amazonaws.com/4.0image/012-Capsicum.png' },
        { name: 'balance', url: 'https://s3.amazonaws.com/4.0image/012-balance.png' },
        { name: 'chicken', url: 'https://s3.amazonaws.com/4.0image/012-chicken.png' },
        { name: 'chili sauce', url: 'https://s3.amazonaws.com/4.0image/012-chili-sauce.png' },
        { name: 'fast food', url: 'https://s3.amazonaws.com/4.0image/012-fast+food.png' },
        { name: 'cauliflower', url: 'https://s3.amazonaws.com/4.0image/013-cauliflower.png' },
        { name: 'fast food', url: 'https://s3.amazonaws.com/4.0image/013-fast+food.png' },
        { name: 'fast basket', url: 'https://s3.amazonaws.com/4.0image/013-food+basket.png' },
        { name: 'knife', url: 'https://s3.amazonaws.com/4.0image/013-knife.png' },
        { name: 'oven', url: 'https://s3.amazonaws.com/4.0image/013-oven.png' },
        { name: 'beer mug', url: 'https://s3.amazonaws.com/4.0image/014-beer+mug.png' },
        { name: 'corn', url: 'https://s3.amazonaws.com/4.0image/014-corn.png' },
        { name: 'mixer', url: 'https://s3.amazonaws.com/4.0image/014-mixer.png' },
        { name: 'sauce', url: 'https://s3.amazonaws.com/4.0image/014-sauce.png' },
        { name: 'waiter', url: 'https://s3.amazonaws.com/4.0image/014-waiter.png' },
        { name: 'chicken leg', url: 'https://s3.amazonaws.com/4.0image/015-chicken-leg.png' },
        { name: 'dragon fruit', url: 'https://s3.amazonaws.com/4.0image/015-dragon+fruit.png' },
        { name: 'fast food', url: 'https://s3.amazonaws.com/4.0image/015-fast+food.png' },
        { name: 'salmon', url: 'https://s3.amazonaws.com/4.0image/015-salmon.png' },
        { name: 'toaster', url: 'https://s3.amazonaws.com/4.0image/015-toaster.png' },
        { name: 'bread loafs', url: 'https://s3.amazonaws.com/4.0image/016-bread+loafs.png' },
        { name: 'chef', url: 'https://s3.amazonaws.com/4.0image/016-chef.png' },
        { name: 'eggplant', url: 'https://s3.amazonaws.com/4.0image/016-eggplant.png' },
        { name: 'kebab', url: 'https://s3.amazonaws.com/4.0image/016-kebab.png' },
        { name: 'fried rice', url: 'https://s3.amazonaws.com/4.0image/017-fried-rice.png' },
        { name: 'garlic', url: 'https://s3.amazonaws.com/4.0image/017-garlic.png' },
        { name: 'noodle', url: 'https://s3.amazonaws.com/4.0image/017-noodle.png' },
        { name: 'soda', url: 'https://s3.amazonaws.com/4.0image/017-soda.png' },
        { name: 'waffle', url: 'https://s3.amazonaws.com/4.0image/017-waffle.png' },
        { name: 'chili pepper', url: 'https://s3.amazonaws.com/4.0image/018-chili-pepper.png' },
        { name: 'fast food', url: 'https://s3.amazonaws.com/4.0image/018-fast+food.png' },
        { name: 'food', url: 'https://s3.amazonaws.com/4.0image/018-food.png' },
        { name: 'green chili+pepper', url: 'https://s3.amazonaws.com/4.0image/018-green+chili+pepper.png' },
        { name: 'pastry', url: 'https://s3.amazonaws.com/4.0image/018-pastry.png' },
        { name: 'canned food', url: 'https://s3.amazonaws.com/4.0image/019-canned+food.png' },
        { name: 'chicken', url: 'https://s3.amazonaws.com/4.0image/019-chicken.png' },
        { name: 'okra', url: 'https://s3.amazonaws.com/4.0image/019-okra.png' },
        { name: 'pot', url: 'https://s3.amazonaws.com/4.0image/019-pot.png' },
        { name: 'whisk', url: 'https://s3.amazonaws.com/4.0image/019-whisk.png' },
        { name: 'canned food', url: 'https://s3.amazonaws.com/4.0image/020-canned+food.png' },
        { name: 'lantern', url: 'https://s3.amazonaws.com/4.0image/020-lantern.png' },
        { name: 'lemon', url: 'https://s3.amazonaws.com/4.0image/020-lemon.png' },
        { name: 'sushi', url: 'https://s3.amazonaws.com/4.0image/020-sushi.png' },
        { name: 'wheat', url: 'https://s3.amazonaws.com/4.0image/020-wheat.png' },
        { name: 'coffee', url: 'https://s3.amazonaws.com/4.0image/021-coffee.png' },
        { name: 'fast food', url: 'https://s3.amazonaws.com/4.0image/021-fast+food.png' },
        { name: 'loaf', url: 'https://s3.amazonaws.com/4.0image/021-loaf.png' },
        { name: 'mango', url: 'https://s3.amazonaws.com/4.0image/021-mango.png' },
        { name: 'sushi roll', url: 'https://s3.amazonaws.com/4.0image/021-sushi+roll.png' },
        { name: 'bucket', url: 'https://s3.amazonaws.com/4.0image/022-bucket.png' },
        { name: 'burger', url: 'https://s3.amazonaws.com/4.0image/022-burger.png' },
        { name: 'orange', url: 'https://s3.amazonaws.com/4.0image/022-orange.png' },
        { name: 'orange', url: 'https://s3.amazonaws.com/4.0image/022-rice+bowl.png' },
        { name: 'smartphone', url: 'https://s3.amazonaws.com/4.0image/022-smartphone.png' },
        { name: 'fish and chips', url: 'https://s3.amazonaws.com/4.0image/023-fish+and+chips.png' },
        { name: 'fortune cookie', url: 'https://s3.amazonaws.com/4.0image/023-fortune-cookie.png' },
        { name: 'kebab', url: 'https://s3.amazonaws.com/4.0image/023-kebab.png' },
        { name: 'papaya', url: 'https://s3.amazonaws.com/4.0image/023-papaya.png' },
        { name: 'pizza', url: 'https://s3.amazonaws.com/4.0image/023-pizza.png' },
        { name: 'chicken', url: 'https://s3.amazonaws.com/4.0image/024-chicken.png' },
        { name: 'cinnamon', url: 'https://s3.amazonaws.com/4.0image/024-cinnamon.png' },
        { name: 'pear', url: 'https://s3.amazonaws.com/4.0image/024-pear.png' },
        { name: 'seafood', url: 'https://s3.amazonaws.com/4.0image/024-seafood.png' },
        { name: 'seafood', url: 'https://s3.amazonaws.com/4.0image/024-wrap.png' },
        { name: 'bento', url: 'https://s3.amazonaws.com/4.0image/025-bento.png' },
        { name: 'fast food', url: 'https://s3.amazonaws.com/4.0image/025-fast+food.png' },
        { name: 'milk', url: 'https://s3.amazonaws.com/4.0image/025-milk.png' },
        { name: 'pomegranate', url: 'https://s3.amazonaws.com/4.0image/025-pomegranate.png' },
        { name: 'taco', url: 'https://s3.amazonaws.com/4.0image/025-taco.png' },
        { name: 'corn dog', url: 'https://s3.amazonaws.com/4.0image/026-corn+dog.png' },
        { name: 'ice cream cup', url: 'https://s3.amazonaws.com/4.0image/026-ice+cream+cup.png' },
        { name: 'pumpkin', url: 'https://s3.amazonaws.com/4.0image/026-pumpkin.png' },
        { name: 'toast', url: 'https://s3.amazonaws.com/4.0image/026-toast.png' },
        { name: 'yin yang', url: 'https://s3.amazonaws.com/4.0image/026-yin-yang.png' },
        { name: 'asian food', url: 'https://s3.amazonaws.com/4.0image/027-asian-food.png' },
        { name: 'corn dog', url: 'https://s3.amazonaws.com/4.0image/027-corn+dog.png' },
        { name: 'piece of cake', url: 'https://s3.amazonaws.com/4.0image/027-piece+of+cake.png' },
        { name: 'rolling pin', url: 'https://s3.amazonaws.com/4.0image/027-rolling-pin.png' },
        { name: 'rose apple', url: 'https://s3.amazonaws.com/4.0image/027-rose+apple.png' },
        { name: 'apple pie', url: 'https://s3.amazonaws.com/4.0image/028-apple-pie.png' },
        { name: 'french fries', url: 'https://s3.amazonaws.com/4.0image/028-french+fries.png' },
        { name: 'pretzel', url: 'https://s3.amazonaws.com/4.0image/028-pretzel.png' },
        { name: 'restaurant', url: 'https://s3.amazonaws.com/4.0image/028-restaurant.png' },
        { name: 'strawberry', url: 'https://s3.amazonaws.com/4.0image/028-strawberry.png' },
        { name: 'coffee cup', url: 'https://s3.amazonaws.com/4.0image/029-coffee+cup.png' },
        { name: 'flour', url: 'https://s3.amazonaws.com/4.0image/029-flour.png' },
        { name: 'kebab', url: 'https://s3.amazonaws.com/4.0image/029-kebab.png' },
        { name: 'sushi', url: 'https://s3.amazonaws.com/4.0image/029-sushi-2.png' },
        { name: 'tomato', url: 'https://s3.amazonaws.com/4.0image/029-tomato.png' },
        { name: 'bagel', url: 'https://s3.amazonaws.com/4.0image/030-bagel.png' },
        { name: 'chips', url: 'https://s3.amazonaws.com/4.0image/030-chips.png' },
        { name: 'sausage', url: 'https://s3.amazonaws.com/4.0image/030-sausage.png' },
        { name: 'tomato sauce', url: 'https://s3.amazonaws.com/4.0image/030-tomato-sauce.png' },
        { name: 'watermelon', url: 'https://s3.amazonaws.com/4.0image/030-watermelon.png' },
        { name: 'biscuit', url: 'https://s3.amazonaws.com/4.0image/031-biscuit.png' },
        { name: 'ice pop', url: 'https://s3.amazonaws.com/4.0image/031-ice+pop.png' },
        { name: 'ice tea', url: 'https://s3.amazonaws.com/4.0image/031-ice-tea.png' },
        { name: 'wrap', url: 'https://s3.amazonaws.com/4.0image/031-wrap.png' },
        { name: 'bread', url: 'https://s3.amazonaws.com/4.0image/032-bread-1.png' },
        { name: 'hamburger', url: 'https://s3.amazonaws.com/4.0image/032-hamburger.png' },
        { name: 'pepper', url: 'https://s3.amazonaws.com/4.0image/032-pepper.png' },
        { name: 'stall', url: 'https://s3.amazonaws.com/4.0image/032-stall.png' },
        { name: 'bread', url: 'https://s3.amazonaws.com/4.0image/033-bread.png' },
        { name: 'chopsticks', url: 'https://s3.amazonaws.com/4.0image/033-chopsticks-1.png' },
        { name: 'pizza', url: 'https://s3.amazonaws.com/4.0image/033-pizza.png' },
        { name: 'stand', url: 'https://s3.amazonaws.com/4.0image/033-stand.png' },
        { name: 'brownie', url: 'https://s3.amazonaws.com/4.0image/034-brownie.png' },
        { name: 'candy bar', url: 'https://s3.amazonaws.com/4.0image/034-candy+bag.png' },
        { name: 'monitor', url: 'https://s3.amazonaws.com/4.0image/034-monitor.png' },
        { name: 'stand', url: 'https://s3.amazonaws.com/4.0image/034-stand.png' },
        { name: 'cake', url: 'https://s3.amazonaws.com/4.0image/035-cake-3.png' },
        { name: 'dimsum', url: 'https://s3.amazonaws.com/4.0image/035-dimsum.png' },
        { name: 'hot dog', url: 'https://s3.amazonaws.com/4.0image/035-hot+dog.png' },
        { name: 'cheese', url: 'https://s3.amazonaws.com/4.0image/036-cheese.png' },
        { name: 'sandwich', url: 'https://s3.amazonaws.com/4.0image/036-sandwich.png' },
        { name: 'sushi', url: 'https://s3.amazonaws.com/4.0image/036-sushi-1.png' },
        { name: 'croissant', url: 'https://s3.amazonaws.com/4.0image/037-croissant.png' },
        { name: 'fries', url: 'https://s3.amazonaws.com/4.0image/037-fries.png' },
        { name: 'tea pot', url: 'https://s3.amazonaws.com/4.0image/037-tea-pot.png' },
        { name: 'chair', url: 'https://s3.amazonaws.com/4.0image/038-chair.png' },
        { name: 'donut', url: 'https://s3.amazonaws.com/4.0image/038-donut.png' },
        { name: 'takoyaki', url: 'https://s3.amazonaws.com/4.0image/038-takoyaki.png' },
        { name: 'bike', url: 'https://s3.amazonaws.com/4.0image/039-bike.png' },
        { name: 'cup cake', url: 'https://s3.amazonaws.com/4.0image/039-cupcake.png' },
        { name: 'noodles', url: 'https://s3.amazonaws.com/4.0image/039-noodles-1.png' },
        { name: 'bar', url: 'https://s3.amazonaws.com/4.0image/040-bar.png' },
        { name: 'bun bread', url: 'https://s3.amazonaws.com/4.0image/040-bun-bread.png' },
        { name: 'fish', url: 'https://s3.amazonaws.com/4.0image/040-fish.png' },
        { name: 'pancakes', url: 'https://s3.amazonaws.com/4.0image/041-pancakes.png' },
        { name: 'sake', url: 'https://s3.amazonaws.com/4.0image/041-sake.png' },
        { name: 'pie', url: 'https://s3.amazonaws.com/4.0image/042-pie.png' },
        { name: 'satay', url: 'https://s3.amazonaws.com/4.0image/042-satay.png' },
        { name: 'curry', url: 'https://s3.amazonaws.com/4.0image/043-curry.png' },
        { name: 'sandwich', url: 'https://s3.amazonaws.com/4.0image/043-sandwich.png' },
        { name: 'cake', url: 'https://s3.amazonaws.com/4.0image/044-cake-2.png' },
        { name: 'sushi', url: 'https://s3.amazonaws.com/4.0image/044-sushi.png' },
        { name: 'cake', url: 'https://s3.amazonaws.com/4.0image/045-cake-1.png' },
        { name: 'chopsticks', url: 'https://s3.amazonaws.com/4.0image/045-chopsticks.png' },
        { name: 'challah', url: 'https://s3.amazonaws.com/4.0image/046-challah.png' },
        { name: 'rice bowl', url: 'https://s3.amazonaws.com/4.0image/046-rice-bowl.png' },
        { name: 'cookies', url: 'https://s3.amazonaws.com/4.0image/047-cookies.png' },
        { name: 'menu', url: 'https://s3.amazonaws.com/4.0image/047-menu.png' },
        { name: 'cake', url: 'https://s3.amazonaws.com/4.0image/048-cake.png' },
        { name: 'hot pot', url: 'https://s3.amazonaws.com/4.0image/048-hot-pot.png' },
        { name: 'gingerbread', url: 'https://s3.amazonaws.com/4.0image/049-gingerbread.png' },
        { name: 'onigiri', url: 'https://s3.amazonaws.com/4.0image/049-onigiri.png' },
        { name: 'birthday cake', url: 'https://s3.amazonaws.com/4.0image/050-birthday-cake.png' },
        { name: 'noodles', url: 'https://s3.amazonaws.com/4.0image/050-noodles.png' },
        { name: 'bacon', url: 'https://s3.amazonaws.com/4.0image/bacon.png' },
        { name: 'beverage', url: 'https://s3.amazonaws.com/4.0image/beverage.png' },
        { name: 'birthday cake', url: 'https://s3.amazonaws.com/4.0image/birthday-cake.png' },
        { name: 'boiled egg', url: 'https://s3.amazonaws.com/4.0image/boiled-egg.png' },
        { name: 'bottle', url: 'https://s3.amazonaws.com/4.0image/bottle.png' },
        { name: 'break fast', url: 'https://s3.amazonaws.com/4.0image/breakfast.png' },
        { name: 'burrito', url: 'https://s3.amazonaws.com/4.0image/brochure.png' },
        { name: 'burrito', url: 'https://s3.amazonaws.com/4.0image/burrito+(3).png' },
        { name: 'burrito', url: 'https://s3.amazonaws.com/4.0image/burrito.png' },
        { name: 'cake', url: 'https://s3.amazonaws.com/4.0image/cake.png' },
        { name: 'cheese', url: 'https://s3.amazonaws.com/4.0image/cheese+(1).png' },
        { name: 'cheese', url: 'https://s3.amazonaws.com/4.0image/cheese.png' },
        { name: 'chicken lag', url: 'https://s3.amazonaws.com/4.0image/chicken-leg.png' },
        { name: 'cocktail', url: 'https://s3.amazonaws.com/4.0image/cocktail.png' },
        { name: 'coke', url: 'https://s3.amazonaws.com/4.0image/coke.png' },
        { name: 'crepe', url: 'https://s3.amazonaws.com/4.0image/crepe.png' },
        { name: 'cupcake ', url: 'https://s3.amazonaws.com/4.0image/cupcake.png' },
        { name: 'egg', url: 'https://s3.amazonaws.com/4.0image/egg.png' },
        { name: 'french fries', url: 'https://s3.amazonaws.com/4.0image/french-fries.png' },
        { name: 'fried chicken', url: 'https://s3.amazonaws.com/4.0image/fried-chicken.png' },
        { name: 'fried egg', url: 'https://s3.amazonaws.com/4.0image/fried-egg.png' },
        { name: 'guacamole', url: 'https://s3.amazonaws.com/4.0image/guacamole.png' },
        { name: 'hamburger', url: 'https://s3.amazonaws.com/4.0image/hamburger.png' },
        { name: 'kebab', url: 'https://s3.amazonaws.com/4.0image/kebab.png' },
        { name: 'meat', url: 'https://s3.amazonaws.com/4.0image/meat+(1).png' },
        { name: 'meat', url: 'https://s3.amazonaws.com/4.0image/meat+(2).png' },
        { name: 'meat', url: 'https://s3.amazonaws.com/4.0image/meat.png' },
        { name: 'menu', url: 'https://s3.amazonaws.com/4.0image/menu.png' },
        { name: 'milk', url: 'https://s3.amazonaws.com/4.0image/milk+(1).png' },
        { name: 'milk shake', url: 'https://s3.amazonaws.com/4.0image/milk-shake.png' },
        { name: 'milk', url: 'https://s3.amazonaws.com/4.0image/milk.png' },
        { name: 'milk shake', url: 'https://s3.amazonaws.com/4.0image/milkshake.png' },
        { name: 'mineral water', url: 'https://s3.amazonaws.com/4.0image/mineral-water.png' },
        { name: 'pizza', url: 'https://s3.amazonaws.com/4.0image/pizza+(1).png' },
        { name: 'pizza', url: 'https://s3.amazonaws.com/4.0image/pizza.png' },
        { name: 'roast chicken', url: 'https://s3.amazonaws.com/4.0image/roast-chicken.png' },
        { name: 'salad', url: 'https://s3.amazonaws.com/4.0image/salad.png' },
        { name: 'salami', url: 'https://s3.amazonaws.com/4.0image/salami.png' },
        { name: 'skewer', url: 'https://s3.amazonaws.com/4.0image/skewer.png' },
        { name: 'soft drink', url: 'https://s3.amazonaws.com/4.0image/soft-drink.png' },
        { name: 'steak', url: 'https://s3.amazonaws.com/4.0image/steak+(1).png' },
        { name: 'steak', url: 'https://s3.amazonaws.com/4.0image/steak.png' },
        { name: 'taco', url: 'https://s3.amazonaws.com/4.0image/taco.png' },
      ],
    };
  },
  computed: {
    filterList() {
      return this.list.filter(item => {
        return item.name.toLowerCase().match(this.search.toLowerCase());
      });
    },
  },
  methods: {
    selectIcon(item) {    
      this.$emit('selected', item);
      this.cancel();
    },
    cancel() {
      this.$emit('canceled', false);
      this.dialog = false;
    },
  }
};
</script>

<style scoped>
.v-dialog__container {
  display: none !important;
}

.image-box {
  overflow: auto;
  height: 600px;
}
</style>
